import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AudioPlayerComponent from './AudioPlayerComponent';
import knowledgeBites from "../../assets/logo/learningLounge/knowledgeBites.png";
import { trackEvent } from '../../utils/gaTracking';
import { useSelector } from 'react-redux';

function KnowledgeNuggets({ playlist }) {
  const [show, setShow] = useState(false);
  const authState = useSelector((state) => state.authUser);
  const user_id = authState?.profile?.user_id;
  const user_email = authState?.profile?.email;

  return (
    <>
      <Modal
        className='momentsModal'
        show={show}
        size='xl'
        centered
        onHide={() => setShow(false)}
        keyboard={false}  // Prevents closing on escape key press
      >
        <Modal.Body>
          <AudioPlayerComponent setShow={setShow} playlist={playlist} />
        </Modal.Body>
      </Modal>
      <div style={{ height: '100%', cursor: 'pointer' }} onClick={() => {trackEvent('hrd_knowledge_bytes_viewed', 'HRD Knowledge Bytes Viewed', 'HRD Knowledge Bytes Viewed', 1, user_id, user_email); setShow(true)}}>
        <img src={knowledgeBites} alt='knowledgeBites' style={{ width: '100%', height: '155px', objectFit: 'contain' }} />
      </div>
    </>
  )
}

export default KnowledgeNuggets

